export default __webpack_public_path__ + "static/media/2-step.f8d8743a.png";